import { ReactNode } from 'react';

interface IProps {
  children: ReactNode;
}

const PageContainer = ({ children }: IProps) => {
  // PageContainer is now just a wrapper - Header/Footer are in MainLayout
  // This component is kept for backward compatibility with existing pages
  return <>{children}</>;
};

export default PageContainer;
